import { createSlice } from '@reduxjs/toolkit';
import { TSectionTypes, TZoomMeetingSectionPaymentType } from '../SectionSlice';

export interface ISectionTemplate {
  _id: string;
  template: string;
  sortingKey: number;
  type: TSectionTypes;
  title: string;
  description?: string;
  sections?: ISectionTemplate[];
  startDate?: string;
  endDate?: string;
  // ZOOM
  dateTime?: string;
  duration?: number;
  tutor?: string;
  paymentType?: TZoomMeetingSectionPaymentType;
  // RESOURCE
  curriculum?: string;
  grade?: string;
  subject?: string;
  subjectCode?: string;
  subjectLevel?: string;
  quiztopiyaTopicId?: string;
  quiztopiyaSubTopicId?: string;
  quiztopiyaTopicName?: string;
  quiztopiyaSubTopicName?: string;
  quiztopiyaResourceUrl?: string;
}

export interface IInitialSectionTemplatesState {
  status: 'idle' | 'loading' | 'rejected';
}

const initialState: IInitialSectionTemplatesState = {
  status: 'idle',
};

export const SectionTemplatesSlice = createSlice({
  name: 'sectionTemplates',
  initialState,
  reducers: {},
  extraReducers: {},
});

export default SectionTemplatesSlice.reducer;
